import Image from 'next/image';
import { fileTypes } from '@/types/common';
import DocumentIcon from '/public/icons/document.svg';

interface ViewFileByTypeProps {
  type: string;
  contentDimensions?: {
    width: number;
    height: number;
  };
  path: string;
  caption: string;
  name: string;
  onLoad?: () => void;
  onError?: () => void;
}

export const ViewFileByType = ({
  type,
  path,
  caption,
  name,
  onLoad,
  onError,
  contentDimensions,
}: ViewFileByTypeProps) => {
  const dimensions = contentDimensions ?? { width: 420, height: 420 };
  const { width, height } = dimensions;

  switch (type) {
    case fileTypes.PDF:
      return (
        <iframe
          src={path}
          width={width}
          height={height}
          allowFullScreen
          onLoad={onLoad}
          onError={onError}
          className="rounded-[13px] max-h-[420px] max-w-[420px]"
        />
      );
    case fileTypes.IMAGE:
      return (
        <Image
          src={path}
          alt={caption ?? name}
          width={width}
          height={height}
          onLoad={onLoad}
          onError={onError}
          className="rounded-[13px] object-cover"
          style={{ maxHeight: height, maxWidth: width }}
        />
      );
    default:
      return (
        <div
          className="rounded-[13px] bg-gray-200 flex flex-col gap-2 items-center justify-center"
          style={{ width, height, maxHeight: height, maxWidth: width }}
        >
          <DocumentIcon className="w-10 h-10 text-blue-300 fill-current" />
          <p className="text-blue-300">{type}</p>
        </div>
      );
  }
};